export default "__VITE_ASSET__tUPxHhrN__"